import React, { useEffect, useState } from "react";
import {
  ContentHeader,
  ContentLogo,
  ContentText,
  ContentTextBold,
  IllustrationContainer,
  ModulesGrid,
} from "./HomeAdminInside.styled";
import logohome from "../../assets/svg/tns-logo-2.0.svg";
import SmallWebIllustration from "../../assets/svg/small-web-illustration.svg";
import { useLazyQuery } from "@apollo/client";
import { ALL_HOME_CONFIGURATIONS } from "../../GraphQL/Queries";
import CardComponent from "../LandingPage/CardComponent/CardComponent";
import { useHistory } from "react-router-dom";

const ROUTE_MAP = {
  Survey: "/Survey",
  Calendar: "/MyCalendar",
  Coaches: "/MyCoaches",
  Engagement: "/MySpaces",
  Gamification: "/MyGames",
  KnowledgeManagement: "/Home",
  Reporting: "/MyCases",
};

const safeParseJSON = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const HomeAdminInside = () => {
  const history = useHistory();
  const [moduleButtons, setModuleButtons] = useState([]);

  const [runQueryAllHomeConfigurations] = useLazyQuery(ALL_HOME_CONFIGURATIONS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.allConfigurationValues) {
        const homeConfigurations = data.allConfigurationValues.filter(
          (record) => record["section"] === "Home"
        );
        const moduleButtonArr = homeConfigurations.filter(
          (record) => record["keyConfigurationValues"].includes("BUTTON_HOME")
        );
        setModuleButtons(moduleButtonArr);
      }
    },
  });

  useEffect(() => {
    runQueryAllHomeConfigurations({ context: { clientName: "LinkUsers" } });
  }, []);

  return (
    <ContentHeader>
        <ContentLogo>
          <img src={logohome} alt="logo tns home" />
        </ContentLogo>
        <IllustrationContainer>
          <img src={SmallWebIllustration} alt="TP Trust&Safety illustration" />
        </IllustrationContainer>
        <ContentText>
          Every day, we think of the best tools to guarantee the well-being of
          our entire community.
        </ContentText>
        <ContentTextBold>
          Explore the modules designed for your well-being:
        </ContentTextBold>
        <ModulesGrid>
          {moduleButtons.map((m) => {
            const recordObj = safeParseJSON(m.value);
            if (!recordObj) return null;
            return (
              <CardComponent
                key={m.keyConfigurationValues || recordObj.id}
                title={recordObj.text}
                id={recordObj.id}
                onClick={() => history.push(ROUTE_MAP[recordObj.id] || "/Home")}
              />
            );
          })}
        </ModulesGrid>
      </ContentHeader>
  );
};

export default HomeAdminInside;
